import { useEffect, useState } from "react";
import { Country } from "./Country";

/*
 * Example country string: Australia: Optus, Telstra\nNew Zealand: Spark
 */
export default function useCOperators(countryStr: string): Country[] {
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    const countryList: Country[] = [];
    const countryEntries = countryStr.split("\n").map(entry => entry.trim());

    for (const entry of countryEntries) {
      if (!entry) continue; // Skip empty entries
      const [name, telcosStr] = entry.split(":").map(part => part.trim());
      const telcos = telcosStr ? telcosStr.split(",").map(telco => telco.trim()) : [];
      countryList.push({ name, telcos });
    }

    setCountries(countryList);
  }, [countryStr]);

  return countries;
}